<template>
    <button
        :disabled="disabled"
        class="vue-button"
        @click="handleClick"
        :class="[
            type ? 'vue-button--' + type : '',
            size ? 'vue-button--' + size : '',
            disabled ? 'vue-button--disabled' : '',
            loading ? 'vue-button--loading' : ''
        ]"
        >
        <i v-if="loading"></i>
        <span v-if="$slots.default"><slot></slot></span>
    </button>
</template>
<script type="text/javascript">
export default {
    props: {
        type: {
            type: String,
            default: 'default' // default blue orange
        },
        size: {
            type: String,
            default: 'medium' // large medium small
        },
        loading: Boolean,
        disabled: Boolean
    },
    data: function () {
        return {
        }
    },
    methods: {
        handleClick (evt) {
            if (!this.loading) {
                this.$emit('click', evt)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .vue-button {
        border-radius: 5px;
        font-size: 12px;
        color: #fff;
        cursor: pointer;
        text-align: center;
        line-height: 1;
        &.vue-button--default {
            background: #fff;
            border: 1px solid #dcdfe6;
            color: #606266;
        }
        &.vue-button--blue {
            background: #1890ff;
            border: 1px solid #1890ff;
        }
        &.vue-button--orange {
            background: #ea6541;
            border: 1px solid #ea6541;
        }

        &.vue-button--large {
            padding: 10px 25px;
        }
        &.vue-button--medium {
            padding: 9px 20px;
        }
        &.vue-button--small {
            padding: 7px 15px;
        }

        &.vue-button--disabled {
            cursor: not-allowed;
        }

        &.vue-button--loading {
            cursor: default;
            position: relative;
            opacity: 0.5;
            i {
                position: absolute;
                top: calc(50% - 10px);
                left: calc(50% - 10px);
                width: 20px;
                height: 20px;
                background: url(~@img/loading-2.gif) no-repeat;
                background-size: 100% 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/lib/button.vue